// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userInfoBar {
    display: flex;
    align-items: center;
    font-family: 'Kim';
}

.barLogo {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.barLogo img {
    width: 38px;
    height: 30px;
}

.userInfoLabel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 24px;
    border: 1px solid #71deff;
    border-radius: 6px;
    margin-left: -16px;
    margin-right: 8px;
    padding-left: 20px;
    padding-right: 8px;
    background-color: #253644;
    gap: 8px;
}

.userInfoLabel span {
    font-weight: 600;
    color: #fff;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.smallLabel {
    font-size: 16px;
}

.bigLabel {
    font-size: 28px;
    /* italic */
    font-style: italic;
}

.eloSpan {
    background-color: #364f63;
    padding: 2px 4px;
    border-radius: 4px;
    font-weight: 400 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/userInfoBar/UserInfoBar.style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iEAAiE;AACrE;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B","sourcesContent":[".userInfoBar {\n    display: flex;\n    align-items: center;\n    font-family: 'Kim';\n}\n\n.barLogo {\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.barLogo img {\n    width: 38px;\n    height: 30px;\n}\n\n.userInfoLabel {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 24px;\n    border: 1px solid #71deff;\n    border-radius: 6px;\n    margin-left: -16px;\n    margin-right: 8px;\n    padding-left: 20px;\n    padding-right: 8px;\n    background-color: #253644;\n    gap: 8px;\n}\n\n.userInfoLabel span {\n    font-weight: 600;\n    color: #fff;\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.smallLabel {\n    font-size: 16px;\n}\n\n.bigLabel {\n    font-size: 28px;\n    /* italic */\n    font-style: italic;\n}\n\n.eloSpan {\n    background-color: #364f63;\n    padding: 2px 4px;\n    border-radius: 4px;\n    font-weight: 400 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
